import React from "react";
import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import styles from "../funnelChart.module.css";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

export function LooseConversionsToggle() {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const toggleLoose = useSelector((state) => state.laser.selectedFilters.toggleLoose);

  return startFrom !== "shows" && startFrom !== "enrollments" ? (
    <>
      <Tooltip id="includeLooseConversions" className={styles.toggleTooltip} />
      <div className="select-box toggle" style={{ width: 203 }}>
        <span
          data-tooltip-id="includeLooseConversions"
          data-tooltip-content={
            toggleLoose
              ? "A client can be counted as enrolled/converted even if they have not completed the other steps in the funnel; Appointment, Show or First Visit."
              : "A client must have an appointment and show to be counted in Enrollment."
          }
        >
          <p className="offers-title">Include Loose Conversions</p>
          <ToggleableButton
            isRadio
            title="loose-toggle"
            isActive={toggleLoose}
            onClick={(val) => dispatch(actionCreators.toggleLoose(val))}
          />
        </span>
      </div>
    </>
  ) : null;
}
